import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const deleteCommentsoldIntegration = {
  name: "deleteCommentsoldIntegration" as const,
  input: z.object({ product: createEnum(CommentsoldIntegrationProduct) }),
  output: z.void(),
};
